import $ from 'jquery';

class TableSignature {
  constructor() {
    document.addEventListener('DOMContentLoaded', this.#init.bind(this));
  }

  #init() {
    const tableSelectedEl = $('.js-table-selected');
    if (!tableSelectedEl.length) {
      return;
    }
    TableSignature.hideForms();
    // eslint-disable-next-line no-unused-vars
    const select = tableSelectedEl.find('span').on('click', TableSignature.handleChange.bind(this));
    // eslint-disable-next-line no-unused-vars
    const form = $('.opentable-form').on('submit', TableSignature.handleSubmit.bind(this));
  }

  static handleChange(event) {
    const table = event.target.parentNode;
    TableSignature.hideForms();
    TableSignature.showFrom(table.dataset.value);
  }

  static handleSubmit(event) {
    const form = $(event.target);
    const date = form.find('.table-reservation__date')?.val();
    const time = form.find('.table-reservation__time')?.val();

    if (date && time) {
      form.find('.table-reservation__date-time').val(`${date}T${time}`);
    }

    return true;
  }

  static hideForms() {
    $('.table-form').hide();
  }

  static showFrom(formId) {
    const form = $(`#table-${formId}`);

    if (form.length) {
      form.show();
    }
  }
}

export default TableSignature;
